import { EPunchValidationType } from "../../../models"

export interface IPunchResult {
    UserId: string
    PunchId: string
    Title: string
    Note: string
    Stage: EPunchStage
    Type: EPunchValidationType
}

export enum EPunchStage {
    CheckValidate,
    Execution
}